import { FooterPages } from './FooterPages';
import { Header } from './Header';
import { Rutas } from './Rutas';
import dataHome from '../../utils/data-pages/data-home.json';

export function Home() {
    return (
        <section className='home'>
            {/* Sección Header */}
            <Header />

            {/* Rutas */}
            <Rutas />

            {/* Sección Footer */}
            {
                dataHome.map((item, index) => (
                    <FooterPages
                        key={index}
                        data={item} />
                ))
            }
        </section>
    );
}